import { render, staticRenderFns } from "./NoHomeworkMoreDialog.vue?vue&type=template&id=0e3268fa&scoped=true"
import script from "./NoHomeworkMoreDialog.vue?vue&type=script&lang=js"
export * from "./NoHomeworkMoreDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3268fa",
  null
  
)

export default component.exports